import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import FileManagement from '../fileManagement';
import LiveStreamSetting from '../liveStreamSettings';
import ProxyStreamSetting from '../proxyStreamSettings';
import RecorderSetting from '../recorderSettings';
import ReplayStreamSetting from '../replayStreamSettings';
import SensorManagementSetting from '../sensorManagementSettings';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" hidden={value !== index}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function MsSettingsTab() {
  const [value, setValue] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setValue(0);
    }, 200);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Replay Stream" {...a11yProps(0)} />
          <Tab label="Live Stream" {...a11yProps(1)} />
          <Tab label="Proxy Stream" {...a11yProps(2)} />
          <Tab label="Stream Recorder" {...a11yProps(3)} />
          <Tab label="Storage management" {...a11yProps(4)} />
          <Tab label="Sensor Management" {...a11yProps(5)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ReplayStreamSetting />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <LiveStreamSetting />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ProxyStreamSetting />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <RecorderSetting />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <FileManagement />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <SensorManagementSetting />
      </TabPanel>
    </Box>
  );
}
